import {BugSnag, PartialShop} from 'packages/@web-utilities/shop';

export interface ServerData {
  [key: string]: any;
  apiKey: string;
  shop: PartialShop;
  locale: string;
  bugsnag: BugSnag;
}

export function getSerialized(): ServerData {
  const node = document.getElementById('app-load-data');
  const data = node?.dataset?.loadData;

  return data ? JSON.parse(data) : {};
}
